export class ObjectsRequest {
    pageNo: number;
    pageLength: number;
    orderBy: string;
    sortColumn: string;
    searchQry: string;
}